import { render } from "./TextCard.vue?vue&type=template&id=07b4cf77"
import script from "./TextCard.vue?vue&type=script&lang=js"
export * from "./TextCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__